/* ============================================================
   CLIENT ACTION TYPES
============================================================ */

// Client Details Actions
export const CLIENT_DETAILS_SUCCESS = "CLIENT_DETAILS_SUCCESS";
export const CLIENT_DETAILS_FAILURE = "CLIENT_DETAILS_FAILURE";
export const CLIENT_DETAILS_RESET = "CLIENT_DETAILS_RESET";

// Client Loading & Error States
export const CLIENT_SET_LOADING = "CLIENT_SET_LOADING";
export const CLIENT_SET_ERROR = "CLIENT_SET_ERROR";
export const CLIENT_CLEAR_ERROR = "CLIENT_CLEAR_ERROR";

// Client Create/Update/Delete Actions
export const CLIENT_CREATE_REQUEST = "CLIENT_CREATE_REQUEST";
export const CLIENT_CREATE_SUCCESS = "CLIENT_CREATE_SUCCESS";
export const CLIENT_CREATE_FAILURE = "CLIENT_CREATE_FAILURE";
export const CLIENT_CREATE_RESET = "CLIENT_CREATE_RESET";

// Client Filter Actions
export const CLIENT_SET_FILTERS = "CLIENT_SET_FILTERS";
export const CLIENT_CLEAR_FILTERS = "CLIENT_CLEAR_FILTERS";

// Client Selection Actions
export const CLIENT_SET_SELECTED = "CLIENT_SET_SELECTED";